import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from './toolbar.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRippleModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IconsModule } from '@shared/icons.module';
import { AngularResizeEventModule } from 'angular-resize-event';
import { VexPopoverComponent } from '@vex/components/vex-popover/vex-popover.component';
import { NavigationItemComponent } from '../navigation/navigation-item/navigation-item.component';
import { NavigationComponent } from '../navigation/navigation.component';
import { MegaMenuComponent } from '../new-toolbar/mega-menu/mega-menu.component';
import { ToolbarOrientationPipe } from '@vex/pipes/toolbar-orientation.pipe';

@NgModule({
  declarations: [ToolbarComponent, ToolbarOrientationPipe],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatRippleModule,
    MatTooltipModule,
    VexPopoverComponent,
    RouterModule,
    NavigationItemComponent,
		NavigationComponent,
    MegaMenuComponent,
    IconsModule,
    AngularResizeEventModule
  ],
  exports: [ToolbarComponent]
})
export class ToolbarModule {
}
